import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CustomerPortal from "./pages/CustomerPortal";

function App() {
  return (
    <div className="App min-h-screen bg-stark-bg">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<CustomerPortal />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
